import axiosInstance from "@/api/axiosInstance";
import { UpdateHeroItemRequest, HeroItem } from "../types";

/**
 * Update an existing hero item
 * PATCH /api/admin/hero-items/{id}
 */
export async function updateHeroItem(
  id: string,
  data: UpdateHeroItemRequest,
): Promise<HeroItem> {
  const response = await axiosInstance.patch<HeroItem>(
    `/api/admin/hero-items/${id}`,
    data,
  );
  return response.data;
}
